import React from 'react';
import { useParams } from 'react-router-dom';
import ContainerValidation from "../../../Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../../Visitor/External/Components/HeaderValidation";
import {getUrlParameters} from "../../../Visitor/External/Model/Model";
import BodyValidation from "../../../Visitor/External/Components/BodyValidation";
import {
    CheckCardIcon
} from "../../../../../components/buttons/IconButtons";
import routes from "../../../../../Routes/routes";
import SuccessfullyRegisteredApp from "../Functionality/SuccessfullyRegisteredApp";
import SuccessfullyEventDetails from "./SuccessfullyEventDetails";

/**
 *
 * @Author: Karen Yunuen pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SuccessfullyRegistered = () => {
    const { eventId } = useParams();
    const {
        t,
        navigate,
        getPublicEventDetail,
        setLatitude,
        setLongitude,
        monthDay,
        latLng,
        direction,
        chipStatus
    } = SuccessfullyRegisteredApp();
    return (
        <ContainerValidation>
            <HeaderValidation
                showBtnBack={false}
                url={getUrlParameters({url: routes.eventDetails.main, id:eventId})}
            />

            <BodyValidation
                showBtnNext={false}
                showBtnPrev={false}
                className={"identity-invitation-body"}
                clickPrev={() => {
                    navigate(getUrlParameters({url:routes.eventDetails.main, id: eventId}))
                }}
            >
                <>
                    <div className={"d-flex justify-content-center"}>
                        <CheckCardIcon className={"icon-color-success-500"} height={54} width={54}/>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("you_have_been_successfully_registered")}</p>
                            <p className="fs-16-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("we_have_sent_your_invitation_by_email")}</p>
                            <p className="fs-16-to-14 ibl-font-w-400 font-color-general-950 text-center">
                                {t("please_check_your_inbox_or_spam_folder")}
                            </p>
                        </div>
                    </div>

                    <SuccessfullyEventDetails
                        latLng={latLng}
                        t={t}
                        setLatitude={setLatitude}
                        setLongitude={setLongitude}
                        getPublicEventDetail={getPublicEventDetail}
                        direction={direction}
                        chipStatus={chipStatus}
                        monthDay={monthDay}
                    />
                </>
            </BodyValidation>
        </ContainerValidation>
    )

}

export default SuccessfullyRegistered
